var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSystems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "#E00E62"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9062 19.0938H19.0938C18.4473 19.0938 17.8273 19.3506 17.3702 19.8077C16.9131 20.2648 16.6562 20.8848 16.6562 21.5312V43.4688C16.6562 44.1152 16.9131 44.7352 17.3702 45.1923C17.8273 45.6494 18.4473 45.9062 19.0938 45.9062H45.9062C46.5527 45.9062 47.1727 45.6494 47.6298 45.1923C48.0869 44.7352 48.3438 44.1152 48.3438 43.4688V21.5312C48.3438 20.8848 48.0869 20.2648 47.6298 19.8077C47.1727 19.3506 46.5527 19.0938 45.9062 19.0938ZM45.9062 21.5312V27.625H19.0938V21.5312H45.9062ZM19.0938 30.0625H27.625V43.4688H19.0938V30.0625ZM45.9062 43.4688H30.0625V30.0625H45.9062V43.4688Z",
    fill: "#FFF5EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSystems);
export default __webpack_public_path__ + "static/media/icon-systems.8525050b30699d9156e6b4909c7b0c4e.svg";
export { ForwardRef as ReactComponent };